module.exports = __webpack_public_path__ + "img/2025-ford-explorer.17bb3931.png";